<template>
  <div class="mallManagement">
    <div class="main">
      <div class="lft">
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          :unique-opened="true"
          background-color="#FFF"
          text-color="#000"
          active-text-color="#1C6AFF"
          router
        >
          <template v-for="item in  newData">
            <el-submenu v-if="item.children && item.children.length" :index="item.path" :key="item.path">
              <template slot="title"><i :class="item.icon"></i><span>{{item.name}}</span></template>
              
              <!-- 二级菜单 -->
              <template v-for="itemChild in item.children">
                <el-submenu v-if="itemChild.children && itemChild.children.length" :index="itemChild.path" :key="itemChild.path">
                    <template slot="title"><i :class="itemChild.icon"></i><span>{{itemChild.name}}</span></template>
                    <!-- 三级菜单 -->
                    <el-menu-item v-for="itemChild_Child in itemChild.children" :index="itemChild_Child .path" :key="itemChild_Child.path">
                    <i :class="itemChild_Child.icon"></i><span slot="title">{{itemChild_Child.name}}</span></el-menu-item>
                </el-submenu>
                
                <el-menu-item
                  v-else
                  :index="itemChild.path"
                  :key="itemChild.path"
                  ><i :class="itemChild.icon"></i
                  ><span slot="title">{{ itemChild.name }}</span></el-menu-item
                >
              </template>
            </el-submenu>
            
            <el-menu-item v-else :index="item.path" :key="item.path"
              ><i :class="item.icon"></i
              ><span slot="title">{{ item.name }}</span></el-menu-item
            >
          </template>

        </el-menu>
      </div>
      <div class="rgt">
        <div class="cont">
          <transition name="el-fade-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
export default {
  name: "merchants",
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  watch:{
    classid: function (val){
      console.log("我变换classID", val);
    }
  },
  data() {
    return {
      isCollapse: false,
      classid: this.$route.params.id, //分类
      newData: [],
      // 三级导航数据结构 [{children:[{children:[{}]}]}]
      activeData: [
        {
          path: "/activeCenter/active",
          name: "活动列表"
        },
        {
          path: "/activeCenter/applicat",
          name: "报名列表"
        }
      ],
    };
  },
  beforeMount(){
    this.newData = this.activeData;
    console.log("xinzhi", this.newData);
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
  },
  
};
</script>

<style lang="scss" scoped>
.mallManagement {
  height: 100%;
  position: relative;
  i {
    color: #fff;
  }
  .main {
    position: absolute;
    top: 0px;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    .lft {
      height: 100%;
      background: #ffffff;
      overflow: hidden;
      .el-menu {
        border: 0;
      }
      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 160px;
        min-height: 400px;
      }
    }
    .rgt {
      flex: 1;
      position: relative;
      .cont {
        position: absolute;
        top: 42px;
        bottom: 0;
        width: 100%;
      }
      .rgt-header {
        height: 0;
        text-align: left;
        color: #000;
        font-size: 16px;
        font-weight: 600;
        background: #fff;
        border-bottom: 1px solid #f1f1f1;
        box-shadow: 0 0 3px #f1f1f1;
        // -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
        // box-shadow: 1px 2px 4px rgba(0, 21, 41, 0.08);
        line-height: 42px;
        font-size: 14px;
        padding-left: 24px;
        .box{
          display: flex;
          align-items: center;
          i{
            color: #000 !important;
            padding-right: 10px;
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.mallManagement {
  .el-menu-item-group__name {
    padding: 0;
  }
}
</style>
